import { render, staticRenderFns } from "./domainDialog.vue?vue&type=template&id=4e97bd3a&scoped=true&"
import script from "./domainDialog.vue?vue&type=script&lang=js&"
export * from "./domainDialog.vue?vue&type=script&lang=js&"
import style0 from "./domainDialog.vue?vue&type=style&index=0&id=4e97bd3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e97bd3a",
  null
  
)

export default component.exports